<template>
  <div>
    <v-menu
      v-model="localOpenModal"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="localDate"
          :label="label"
          :rules="rules"
          v-on="on"
          @input="$emit('input', localDate)"
          @click:append="localOpenModal = true"
          filled
          v-mask="'####-##-##'"
          append-icon="mdi-calendar"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="localDate"
        @input="inputDate()"
      ></v-date-picker>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'DatePicker',
  props: {
    openModal: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Date',
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localOpenModal: this.openModal,
      localDate: this.value,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.setLocalDate();
      },
    },
  },
  mounted() {
    this.setLocalDate();
  },
  methods: {
    inputDate() {
      this.localOpenModal = false;
      this.$emit('input', this.localDate);
    },
    setLocalDate() {
      if (this.value?.length > 10) {
        this.localDate = this.value.substring(0, 10);
      } else {
        this.localDate = this.value ?? '';
      }
    },
  },
};
</script>
